// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1LUZL","label":"Radio_label__1N6fN","checkMark":"Radio_checkMark__2NVc0","disabled":"Radio_disabled__38Vng"};